import { Button } from "@/components/ui/button";
import { useDialogs } from "@toolpad/core";
import { Plus } from "lucide-react";
import { NewSkillDialog } from "./dialogs/NewSkillDialog";

export const AddSkillButton = () => {
    const dialogs = useDialogs();

    const handleClick = async () => {
        await dialogs.open(NewSkillDialog);
    };

    return (
        <Button onClick={handleClick}>
            <Plus /> Create
        </Button>
    );
};
